const feedbackList = [
  {
    id: 1,
    name: "Gusto",
    img: "chief.jpg",
    review: "The greatest burger I have ever had in my life.",
    stars: "5",
    email: "gusto@example.com",
  },
  {
    id: 2,
    name: "Benjamin",
    img: "foodEater.png",
    review: "I want to have meals from this shop every day.",
    stars: "4",
    email: "benjamin@example.com",
  },
  {
    id: 3,
    name: "Thomas",
    img: "tom.png",
    review:
      "It took me more than 30 minutes to reach this restaurant and the taste gives over the satisfaction. Worth it!",
    stars: "5",
    email: "thomas@example.com",
  },
  {
    id: 4,
    name: "Lucy",
    img: "eaterGirl.jpg",
    review:
      "Burger and fries make my stress run away. It's a good pleasure by the taste.",
    stars: "4",
    email: "lucy@example.com",
  },
  {
    id: 5,
    name: "Leo",
    img: "eaterMan.jpg",
    review:
      "Food with good quality, great taste, and fair prices. It's amazing!",
    stars: "5",
    email: "leo@example.com",
  },
  {
    id: 6,
    name: "Chris",
    img: "chris.jpg",
    review:
      "The food exceeded my expectations! The flavors were incredible, and the prices were very reasonable. I highly recommend it!",
    stars: "5",
    email: "chris@example.com",
  },
];

export default feedbackList;
